import { gql } from '@apollo/client/core';

export default gql`
  query useEmissionFactorsCsv {
    getEmissionFactorsCsv
  }
`;
